(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["faq"] && !Shopify.designMode) return;
  try {
    
(function(){var els=document.querySelectorAll('[data-mlgq-reveal]');if('IntersectionObserver' in window){var io=new IntersectionObserver(function(en){en.forEach(function(e){if(e.isIntersecting){e.target.classList.add('mlgq-in');io.unobserve(e.target)}})},{threshold:.12});els.forEach(function(e){io.observe(e)});}else{els.forEach(function(e){e.classList.add('mlgq-in')});}document.querySelectorAll('.mlgq-section').forEach(function(sec){var items=sec.querySelectorAll('.mlgq-item');items.forEach(function(item){var q=item.querySelector('.mlgq-q'),a=item.querySelector('.mlgq-a');q.addEventListener('click',function(){var open=item.classList.contains('open');items.forEach(function(i){i.classList.remove('open');i.querySelector('.mlgq-a').style.maxHeight=null});if(!open){item.classList.add('open');a.style.maxHeight=a.scrollHeight+'px';}});});});})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"] && !Shopify.designMode) return;
  try {
    
(function(){var els=document.querySelectorAll('[data-mlgt-reveal]');if(!('IntersectionObserver' in window)){els.forEach(function(e){e.classList.add('mlgt-in')});return;}var io=new IntersectionObserver(function(en){en.forEach(function(e){if(e.isIntersecting){e.target.classList.add('mlgt-in');io.unobserve(e.target)}})},{threshold:.14});els.forEach(function(e){io.observe(e)});})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"] && !Shopify.designMode) return;
  try {
    
(function(){var burger=document.getElementById('mlgBurger'),menu=document.getElementById('mlgMobileMenu');window.addEventListener('scroll',function(){document.body.classList.toggle('mlg-scrolled',window.scrollY>12)},{passive:true});if(burger&&menu){burger.addEventListener('click',function(){var open=burger.classList.toggle('mlg-open');menu.classList.toggle('mlg-show',open);burger.setAttribute('aria-expanded',open);burger.setAttribute('aria-label',open?'Chiudi menu':'Apri menu')});menu.querySelectorAll('a').forEach(function(a){a.addEventListener('click',function(){burger.classList.remove('mlg-open');menu.classList.remove('mlg-show');burger.setAttribute('aria-expanded',false)})})}})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-michelangelo"] && !Shopify.designMode) return;
  try {
    
(function(){var els=document.querySelectorAll('[data-mlgh-reveal]');if(!('IntersectionObserver' in window)){els.forEach(function(e){e.classList.add('mlgh-in')});return;}var io=new IntersectionObserver(function(en){en.forEach(function(e){if(e.isIntersecting){e.target.classList.add('mlgh-in');io.unobserve(e.target)}})},{threshold:.12});els.forEach(function(e){io.observe(e)});})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ilmaestro"] && !Shopify.designMode) return;
  try {
    
(function(){var els=document.querySelectorAll('[data-mlgm-reveal]');if(!('IntersectionObserver' in window)){els.forEach(function(e){e.classList.add('mlgm-in')});return;}var io=new IntersectionObserver(function(en){en.forEach(function(e){if(e.isIntersecting){e.target.classList.add('mlgm-in');io.unobserve(e.target)}})},{threshold:.15});els.forEach(function(e){io.observe(e)});})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart"] && !Shopify.designMode) return;
  try {
    
(function(){
  function money(cents){try{return (cents/100).toLocaleString('it-IT',{style:'currency',currency:(window.Shopify&&Shopify.currency&&Shopify.currency.active)||'EUR'});}catch(e){return '€'+(cents/100).toFixed(2);}}
  function setBusy(row,on){row.style.opacity=on?'.5':'';row.style.pointerEvents=on?'none':'';}
  function change(key,qty,row){setBusy(row,true);fetch(window.Shopify&&Shopify.routes?Shopify.routes.root+'cart/change.js':'/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({id:key,quantity:qty})}).then(function(r){return r.json();}).then(function(){window.location.reload();}).catch(function(){setBusy(row,false);});}
  document.querySelectorAll('.mlgk-item').forEach(function(row){
    var key=row.getAttribute('data-key'),input=row.querySelector('[data-qty]');
    var minus=row.querySelector('.mlgk-minus'),plus=row.querySelector('.mlgk-plus'),rm=row.querySelector('[data-remove]');
    function val(){return Math.max(0,parseInt(input.value)||0);}
    if(minus)minus.addEventListener('click',function(){var n=Math.max(0,val()-1);input.value=n;change(key,n,row);});
    if(plus)plus.addEventListener('click',function(){var n=val()+1;input.value=n;change(key,n,row);});
    if(input)input.addEventListener('change',function(){change(key,val(),row);});
    if(rm)rm.addEventListener('click',function(){change(key,0,row);});
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["michelangelo-acquisto"] && !Shopify.designMode) return;
  try {
    
(function(){
  function money(cents,cur){try{return (cents/100).toLocaleString('it-IT',{style:'currency',currency:cur});}catch(e){return '€'+(cents/100).toFixed(2);}}
  var cur=(window.Shopify&&Shopify.currency&&Shopify.currency.active)||'EUR';
  // reveal
  var els=document.querySelectorAll('[data-mlga-reveal]');
  if('IntersectionObserver' in window){var io=new IntersectionObserver(function(en){en.forEach(function(e){if(e.isIntersecting){e.target.classList.add('mlga-in');io.unobserve(e.target)}})},{threshold:.15});els.forEach(function(e){io.observe(e)});}else{els.forEach(function(e){e.classList.add('mlga-in')});}
  // qty
  document.querySelectorAll('.mlga-qty').forEach(function(box){var i=box.querySelector('.mlga-qtyinput'),m=box.querySelector('.mlga-minus'),p=box.querySelector('.mlga-plus');if(m)m.addEventListener('click',function(){i.value=Math.max(1,(parseInt(i.value)||1)-1)});if(p)p.addEventListener('click',function(){i.value=(parseInt(i.value)||1)+1})});
  // variants per section
  document.querySelectorAll('.mlga-section').forEach(function(sec){
    var id=sec.id,dataEl=document.getElementById('mlga-data-'+id);if(!dataEl)return;
    var variants;try{variants=JSON.parse(dataEl.textContent);}catch(e){return;}
    var form=sec.querySelector('form');if(!form)return;
    var varInput=sec.querySelector('#mlga-varid-'+id),priceBox=sec.querySelector('#mlga-price-'+id),addBtn=sec.querySelector('#mlga-add-'+id),addLbl=addBtn?addBtn.querySelector('.lbl'):null,nameVar=sec.querySelector('#mlga-name-var-'+id),img=sec.querySelector('#mlga-img-'+id),save=sec.querySelector('#mlga-save-'+id);
    var addDefault=addLbl?addLbl.textContent:'Aggiungi al carrello';
    function selected(){var v=[];sec.querySelectorAll('.mlga-option').forEach(function(o){var c=o.querySelector('input:checked');if(c)v.push(c.value);});return v;}
    function pills(){sec.querySelectorAll('.mlga-pill').forEach(function(p){p.classList.toggle('active',p.querySelector('input').checked);});}
    function render(){
      pills();var vals=selected();if(!vals.length)return;
      var m=variants.find(function(v){return (v.options||[]).every(function(o,i){return o===vals[i];});});
      if(!m){if(addBtn)addBtn.disabled=true;if(addLbl)addLbl.textContent='Non disponibile';return;}
      if(varInput)varInput.value=m.id;
      if(priceBox){var h=(m.compare_at_price&&m.compare_at_price>m.price)?'<span class="mlga-price">'+money(m.price,cur)+'</span><span class="mlga-compare">'+money(m.compare_at_price,cur)+'</span>':'<span class="mlga-price">'+money(m.price,cur)+'</span>';priceBox.innerHTML=h;}
      if(save){if(m.compare_at_price&&m.compare_at_price>m.price){save.style.display='';save.textContent='−'+Math.round((m.compare_at_price-m.price)*100/m.compare_at_price)+'%';}else{save.style.display='none';}}
      if(nameVar){nameVar.textContent=(m.title&&m.title!=='Default Title')?(' · '+m.title):'';}
      if(addBtn){addBtn.disabled=!m.available;if(addLbl)addLbl.textContent=m.available?addDefault:'Esaurito';}
      if(img&&m.featured_image){var u=m.featured_image.src||m.featured_image;if(u){img.style.opacity=0;var pre=new Image();pre.onload=function(){img.src=u;img.style.opacity=1;};pre.src=u;}}
    }
    sec.querySelectorAll('.mlga-pill input').forEach(function(i){i.addEventListener('change',render);});
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["michelangelo-consulenza"] && !Shopify.designMode) return;
  try {
    
(function(){var els=document.querySelectorAll('[data-mlgc-reveal]');if(!('IntersectionObserver' in window)){els.forEach(function(e){e.classList.add('mlgc-in')});return;}var io=new IntersectionObserver(function(en){en.forEach(function(e){if(e.isIntersecting){e.target.classList.add('mlgc-in');io.unobserve(e.target)}})},{threshold:.14});els.forEach(function(e){io.observe(e)});})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["michelangelo-farina"] && !Shopify.designMode) return;
  try {
    
(function(){var els=document.querySelectorAll('[data-mlgf-reveal]');if(!('IntersectionObserver' in window)){els.forEach(function(e){e.classList.add('mlgf-in')});return;}var io=new IntersectionObserver(function(en){en.forEach(function(e){if(e.isIntersecting){e.target.classList.add('mlgf-in');io.unobserve(e.target)}})},{threshold:.15});els.forEach(function(e){io.observe(e)});})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["michelangelo-valori"] && !Shopify.designMode) return;
  try {
    
(function(){var els=document.querySelectorAll('[data-mlgn-reveal]');if(!('IntersectionObserver' in window)){els.forEach(function(e){e.classList.add('mlgn-in')});return;}var io=new IntersectionObserver(function(en){en.forEach(function(e){if(e.isIntersecting){e.target.classList.add('mlgn-in');io.unobserve(e.target)}})},{threshold:.14});els.forEach(function(e){io.observe(e)});})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["michelangelo-video"] && !Shopify.designMode) return;
  try {
    
(function(){
  var els=document.querySelectorAll('[data-mlgv-reveal]');
  if('IntersectionObserver' in window){var io=new IntersectionObserver(function(en){en.forEach(function(e){if(e.isIntersecting){e.target.classList.add('mlgv-in');io.unobserve(e.target)}})},{threshold:.15});els.forEach(function(e){io.observe(e)});}else{els.forEach(function(e){e.classList.add('mlgv-in')});}
  document.querySelectorAll('.mlgv-section').forEach(function(section){
    var player=section.querySelector('.mlgv-player');if(!player)return;
    var cap=section.querySelector('.mlgv-caption'),k=cap?cap.querySelector('.k'):null,t=cap?cap.querySelector('.t'):null,poster=player.querySelector('.mlgv-poster');
    var f=section.querySelector('.mlgv-thumb'),current=f?{k:f.dataset.k,t:f.dataset.t,url:f.dataset.url,poster:f.dataset.poster||''}:{k:'',t:'',url:'',poster:''};
    function embed(url){if(!url)return '<div style="position:absolute;inset:0;display:flex;align-items:center;justify-content:center;color:#fff;background:#152029;text-align:center;padding:20px">Collega un video (YouTube, Vimeo o MP4)</div>';var yt=url.match(/(?:youtube\.com\/.*v=|youtu\.be\/)([\w-]{11})/);if(yt)return '<iframe src="https://www.youtube.com/embed/'+yt[1]+'?autoplay=1" allow="autoplay; encrypted-media" allowfullscreen></iframe>';var vm=url.match(/vimeo\.com\/(?:.*\/)?(\d+)/);if(vm)return '<iframe src="https://player.vimeo.com/video/'+vm[1]+'?autoplay=1" allow="autoplay; fullscreen" allowfullscreen></iframe>';return '<video src="'+url+'" controls autoplay playsinline></video>';}
    function reset(){var e=player.querySelector('.mlgv-embed');if(e)e.remove();if(!player.querySelector('.mlgv-play')){var b=document.createElement('button');b.className='mlgv-play';b.innerHTML='<svg viewBox="0 0 24 24" fill="currentColor"><path d="M8 5v14l11-7z"/></svg>';b.addEventListener('click',play);player.appendChild(b);}if(k)k.textContent=current.k;if(t)t.textContent=current.t;if(poster&&current.poster)poster.setAttribute('src',current.poster);}
    function play(){var w=document.createElement('div');w.className='mlgv-embed';w.innerHTML=embed(current.url);player.appendChild(w);var b=player.querySelector('.mlgv-play');if(b)b.remove();}
    var pb=player.querySelector('.mlgv-play');if(pb)pb.addEventListener('click',play);
    section.querySelectorAll('.mlgv-thumb').forEach(function(th){th.addEventListener('click',function(){section.querySelectorAll('.mlgv-thumb').forEach(function(x){x.classList.remove('active')});th.classList.add('active');current={k:th.dataset.k,t:th.dataset.t,url:th.dataset.url,poster:th.dataset.poster||''};reset();});});
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["processo"] && !Shopify.designMode) return;
  try {
    
(function(){var els=document.querySelectorAll('[data-mlgp-reveal]');if(!('IntersectionObserver' in window)){els.forEach(function(e){e.classList.add('mlgp-in')});return;}var io=new IntersectionObserver(function(en){en.forEach(function(e){if(e.isIntersecting){e.target.classList.add('mlgp-in');io.unobserve(e.target)}})},{threshold:.15});els.forEach(function(e){io.observe(e)});})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-information"] && !Shopify.designMode) return;
  try {
    
(function(){
  document.querySelectorAll('.mlgpp-section').forEach(function(sec){
    var id=sec.id;
    // reveal
    var els=sec.querySelectorAll('[data-mlgpp-reveal]');
    if('IntersectionObserver' in window){var io=new IntersectionObserver(function(en){en.forEach(function(e){if(e.isIntersecting){e.target.classList.add('mlgpp-in');io.unobserve(e.target)}})},{threshold:.12});els.forEach(function(e){io.observe(e)});}else{els.forEach(function(e){e.classList.add('mlgpp-in')});}
    // thumbs
    var main=sec.querySelector('.mlgpp-main');
    sec.querySelectorAll('.mlgpp-thumb').forEach(function(t){t.addEventListener('click',function(){sec.querySelectorAll('.mlgpp-thumb').forEach(function(x){x.classList.remove('active')});t.classList.add('active');if(main&&t.dataset.full){main.style.opacity=0;var img=new Image();img.onload=function(){main.src=t.dataset.full;main.style.opacity=1;};img.src=t.dataset.full;}});});
    // qty
    var qi=sec.querySelector('.mlgpp-qtyinput'),mn=sec.querySelector('.mlgpp-minus'),pl=sec.querySelector('.mlgpp-plus');
    if(mn)mn.addEventListener('click',function(){qi.value=Math.max(1,(parseInt(qi.value)||1)-1)});
    if(pl)pl.addEventListener('click',function(){qi.value=(parseInt(qi.value)||1)+1});
    // accordion
    sec.querySelectorAll('.mlgpp-acc-item').forEach(function(item){var q=item.querySelector('.mlgpp-acc-q'),a=item.querySelector('.mlgpp-acc-a');q.addEventListener('click',function(){var open=item.classList.contains('open');item.classList.toggle('open',!open);a.style.maxHeight=open?null:a.scrollHeight+'px';});});
    // variants
    var dataEl=document.getElementById('mlgpp-data-'+id);if(!dataEl)return;var variants;try{variants=JSON.parse(dataEl.textContent);}catch(e){return;}
    var form=sec.querySelector('.mlgpp-form');if(!form)return;
    var varInput=sec.querySelector('#mlgpp-varid-'+id),priceBox=sec.querySelector('#mlgpp-price-'+id),addBtn=sec.querySelector('#mlgpp-add-'+id),addLbl=addBtn?addBtn.querySelector('.lbl'):null;
    var cur=(window.Shopify&&Shopify.currency&&Shopify.currency.active)||'EUR';
    function money(c){try{return (c/100).toLocaleString('it-IT',{style:'currency',currency:cur});}catch(e){return '€'+(c/100).toFixed(2);}}
    function selectedValues(){var vals=[];form.querySelectorAll('.mlgpp-option').forEach(function(opt){var checked=opt.querySelector('input:checked');if(checked)vals.push(checked.value);});return vals;}
    function pills(){form.querySelectorAll('.mlgpp-pill').forEach(function(p){var inp=p.querySelector('input');p.classList.toggle('active',inp.checked);});}
    function update(){
      pills();
      var vals=selectedValues();if(!vals.length){return;}
      var match=variants.find(function(v){return (v.options||[]).every(function(o,i){return o===vals[i];});});
      if(!match){if(addBtn){addBtn.disabled=true;}if(addLbl)addLbl.textContent='Combinazione non disponibile';return;}
      if(varInput)varInput.value=match.id;
      if(priceBox){var html='';if(match.compare_at_price&&match.compare_at_price>match.price){html='<span class="mlgpp-price sale">'+money(match.price)+'</span><span class="mlgpp-compare">'+money(match.compare_at_price)+'</span>';}else{html='<span class="mlgpp-price">'+money(match.price)+'</span>';}priceBox.innerHTML=html;}
      if(addBtn){addBtn.disabled=!match.available;if(addLbl)addLbl.textContent=match.available?(addBtn.getAttribute('data-label')||addLbl.textContent):'Esaurito';}
      if(match.featured_image&&main){var url=match.featured_image.src?match.featured_image.src:match.featured_image;if(url){main.src=url.replace(/(\.[a-z]+)(\?|$)/i,'_1100x$1$2');}}
    }
    if(addBtn&&addLbl)addBtn.setAttribute('data-label',addLbl.textContent);
    form.querySelectorAll('.mlgpp-pill input').forEach(function(i){i.addEventListener('change',update);});
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["recensioni"] && !Shopify.designMode) return;
  try {
    
(function(){var els=document.querySelectorAll('[data-mlgr-reveal]');if(!('IntersectionObserver' in window)){els.forEach(function(e){e.classList.add('mlgr-in')});return;}var io=new IntersectionObserver(function(en){en.forEach(function(e){if(e.isIntersecting){e.target.classList.add('mlgr-in');io.unobserve(e.target)}})},{threshold:.14});els.forEach(function(e){io.observe(e)});})();

  } catch(e) { console.error(e); }
})();
})();
